// Third Party
import * as $ from "jquery";

// Constants
import { FREQUENCY_PRICE, FREQUENCY_API_CODE, PERIOD_CODE } from "@/app/constants/subscription-constants.js";
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants";

// Services
import SubscriptionService from "@/app/services/main/subscription/subscription-service.js";
import cartService from "@/app/services/main/cart/cart-service.js";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

// Components
const ProductItemCard = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "product-item-card" */ "@/app/views/main-view/_shared/_components/product-item-card/product-item-card.vue"
    );

export default {
    name: "ProductItemModal",
    mixins: [toastMessageMixins, userMixins, shoppingMixins],
    components: { ProductItemCard },
    props: {
        modalContent: {
            type: Object,
            required: true,
        },
        petId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            quantity: 1,
            selectedFrequencyList: "P1M",
            selectedPeriodList: null,
            isFrequencyListLoading: false,
            isPeriodListLoading: false,
            frequencyList: [],
            periodList: [],
            periodListDisplay: [],
            // table
            theads: [
                { name: "Image", sortLabel: null, isDesc: false, style: null },
                { name: "Product Name", sortLabel: null, isDesc: false, style: null },
                { name: "Quantity", sortLabel: null, isDesc: false, style: null },
            ],
            isAPILoading: false,
            ageList: {
                A: "Adult",
                P: "Puppy",
            },
            isReadMore: false,
            isBuyNowLoading: false,
        };
    },
    created() {
        this.getSubscriptionPeriod();
    },
    beforeDestroy() {
        this.closeModal();
    },
    computed: {
        isDisabled() {
            if (this.modalContent.subscriptionBundle) {
                return !this.selectedPeriodList;
            } else {
                return false;
            }
        },
    },
    watch: {
        selectedFrequencyList: {
            immediate: true,
            deep: true,
            handler(newValue) {
                this.periodListDisplay = [...this.periodList];
                if (newValue === FREQUENCY_API_CODE.P12M) {
                    this.periodListDisplay.shift();
                    if (this.selectedPeriodList) {
                        if (this.selectedPeriodList.code === PERIOD_CODE.P6M) {
                            this.selectedPeriodList = "";
                        }
                    }
                }
            },
        },
    },
    methods: {
        clearModal() {
            this.selectedFrequencyList = "P1M";
            this.selectedPeriodList = "";
            this.periodListDisplay = [...this.periodList];
            this.quantity = 1;
        },
        show() {
            this.clearModal();
            $(this.$refs.productModal).modal("show");
        },
        closeModal() {
            this.clearModal();
            $(this.$refs.productModal).modal("hide");
        },
        numberOnlyInput(event) {
            const charCode = event.which ? event.which : event.keyCode;

            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            } else {
                return true;
            }
        },
        setQuantity() {
            this.quantity = this.quantity === "" || this.quantity === "0" ? 1 : this.quantity;
        },
        hasProductImage(productImage) {
            const image = require("@/assets/images/temporary/product-image.png");

            return productImage ? productImage : image;
        },
        addToCart(isCheckOut) {
            // check if add to cart is disabled
            if (this.isDisabled) {
                return;
            }

            if (!isCheckOut) {
                this.isAPILoading = true;
            }

            // set cart details
            let cartDetails = {
                bundleId: this.modalContent.id,
                quantity: this.quantity,
            };

            // additional details for subscription products
            if (this.modalContent.subscriptionBundle) {
                cartDetails.subscriptionPeriodCode = this.selectedPeriodList.code;
                cartDetails.paymentFrequencyCode = this.selectedFrequencyList;
            }

            cartService.postCart(this.petId, cartDetails).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    // show toast message
                    const { SUCCESS_ADD_CART } = this.toastMessages.cart(this.modalContent.name);
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_CART, 300);
                    this.setCartCount(this.petId);
                    this.closeModal();
                    this.$emit("refreshCartDetails");

                    this.redirectToCheckout(isCheckOut);
                } else if (res.status === 409 && isCheckOut) {
                    this.updateCartContent(cartDetails, isCheckOut);
                } else {
                    const { ERROR_ADD_CART } = this.toastMessages.cart(this.modalContent.name);
                    this.showAPIErrorToast(ERROR_ADD_CART, res, 300);
                }

                this.isAPILoading = false;
                this.isBuyNowLoading = false;
            });
        },
        updateCartContent(cartDetails, isCheckOut) {
            cartService.putCart(this.getActivePet.id, cartDetails.bundleId, cartDetails).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.redirectToCheckout(isCheckOut);
                }
            });
        },
        redirectToCheckout(isCheckOut) {
            if (isCheckOut) {
                this.$router.push("/products/checkout?bundle=" + this.modalContent.id);
            }
        },
        checkIfMultipleBrands(bundleProducts) {
            // Remove Null and Duplicate Brands in a single Product List.
            const brands = [...new Set(bundleProducts.map((item) => item.brand.name))];

            return {
                name: brands.length > 1 ? "MULTIPLE BRANDS" : brands[0],
                brands,
                isMultiple: brands.length > 1,
            };
        },
        getSubscriptionPeriod() {
            this.isAPILoading = true;
            SubscriptionService.getSubscriptionPeriod().then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    // Added key Monthly, Quarterly and Yearly
                    this.frequencyList = res.data.paymentFrequency;
                    this.periodList = res.data.subscriptionPeriod;
                    this.periodListDisplay = [...this.periodList];
                }
                this.isAPILoading = false;
            });
        },
        getPrice(frequency) {
            return this.modalContent[FREQUENCY_PRICE[frequency]];
        },
        buyNow() {
            this.isBuyNowLoading = true;
            this.addToCart(true);
        },
    },
};
